import type { Asserts } from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { wohSchema } from '@/features/Sparten/woh/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = wohSchema.concat(baseSchema);

export type InputStore = Asserts<typeof inputSchema>;

export const useWohInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'WohInputStore',
);
